(ns hai.home.routes
  (:require
   [hai.home.desktop :as desktop]
   [hai.home.events]
   [hai.home.mobile :as mobile]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as routing]))

(defn routes []
  [["/home"
    {:name :home/view
     ::routing/window-title "Home"
     :label "Home"
     :icon (icons/mui-icon :outlined :cottage)
     :view desktop/page
     :mobile-view mobile/body
     :mobile-chrome-class "sage-bg"
     :controllers [{:start (fn [] (>e [:home/init]))
                    :stop (fn [] (>e [:home/teardown]))}]}]
   ;; The old "/desktop" path is kept as a redirect so bookmarks/emails and the
   ;; browser extension's new-tab iframe (already-installed copies can't
   ;; redeploy on our schedule) keep working.
   ["/desktop"
    {:name :home/desktop-redirect
     :controllers [{:start (fn [] (>e [:routing/navigate [:home/view]]))}]}]])
